// import EventManager from './EventManager';
import messageModel from "../../src/model/MessageModel";
import AppEventManager from "./AppEventManagerService";

export class FlashMessenger {
    public messages = [];
    public addMessage(type: string, body: string, duration = 5) {
        AppEventManager.emit('flash-message', {
            type, body, duration
        });
    }
    public async addMessageById(messageId, type, duration = undefined, messageParams = undefined) {
        let message = await messageModel.getById(messageId, messageParams);
        this.addMessage(type, message.text, duration);
    };

    public async toastById(messageId, type = undefined, duration = undefined, messageParams = undefined) {
        const message = await messageModel.getById(messageId, messageParams);
        this.addMessage(type, message.text, duration);
    };
    public async toastByMessage(message, type = undefined, duration = undefined, messageParams = undefined) {
        this.addMessage(type, message, duration);
    };

    public refresh() {
        this.messages = this.messages.splice(0);
    }

    public remove(id) {
        for (let m of this.messages) {
            if (m.id == id) {
                this.messages.splice(this.messages.indexOf(m), 1);
            }
        }
    };
}
export default new FlashMessenger();